// Modifier Validation Functions

const policyNumber = (chosenTermValue, lob) => {
    const POLICY_NUMBER_PATTERNS = {
        COMMON: '^[0-9]{9,10}$',
        A: '^A[0-9]{9,10}$',
        H: '^H[0-9]{9,10}$',
        U: '^U[0-9]{9,10}$'
    };

    const commonRe = new RegExp(POLICY_NUMBER_PATTERNS.COMMON);
    const isCommonValid = commonRe.test(chosenTermValue);
    if (!isCommonValid && lob) {
        const lobRe = new RegExp(POLICY_NUMBER_PATTERNS[lob]);
        return lobRe.test(chosenTermValue);
    }
    return isCommonValid;
};

const isPolicyNumberContainsALetter = (chosenTermValue) => {
    const PATTERN = '.*[a-zA-Z].*$';
    const re = RegExp(PATTERN);

    return re.test(chosenTermValue);
};

const number = (chosenTermValue, size) => {
    const NUMBER_PATTERNS = size && size.length > 0 ? `^[0-9]{${size}}$` : '^[0-9]+$';
    const re = new RegExp(NUMBER_PATTERNS);

    return re.test(chosenTermValue);
};

const phone = (chosenTermValue) => {
    const PHONE_PATTERN = '^[2-9]\\d{9}$';
    const re = new RegExp(PHONE_PATTERN);

    return re.test(chosenTermValue);
};

const registeredFuncs = {
    policyNumber: policyNumber,
    number: number,
    phone: phone,
    isPolicyNumberContainsALetter: isPolicyNumberContainsALetter
};

const isModifierValid = (chosenTermValue, funcName, optionalParams) => {
    // Run custom validations
    const func = registeredFuncs[funcName];

    if (optionalParams) {
        return func(chosenTermValue, ...optionalParams);
    }
    return func(chosenTermValue);
};

export default {
    isModifierValid: isModifierValid
};
